/* eslint-disable import/no-extraneous-dependencies, global-require */

import { createStore, applyMiddleware, compose } from 'redux';
import { persistStore, persistReducer } from 'redux-persist';

import ReduxThunk from 'redux-thunk';

import createSagaMiddleware from 'redux-saga';

import addressesSagas from 'app/ducks/addresses/sagas';
import authenticationSagas from 'app/ducks/authentication/sagas';
import bankAccountsSagas from 'app/ducks/bankAccounts/sagas';
import bulkMatchPaymentsSagas from 'app/ducks/bulkMatchPayments/sagas';
import clubsSagas from 'app/ducks/clubs/sagas';
import usersSagas from 'app/ducks/users/sagas';
import teamsSagas from 'app/ducks/teams/sagas';
import teamMembersSagas from 'app/ducks/teamMembers/sagas';
import teamConnectionsSagas from 'app/ducks/teamConnections/sagas';
import organisationsSagas from 'app/ducks/organisations/sagas';
import globalSagas from 'app/ducks/global/sagas';
import loadingSagas from 'app/ducks/loading/sagas';
import paymentsSagas from 'app/ducks/payments/sagas';
import matchPaymentsSagas from 'app/ducks/matchPayments/sagas';
import paymentCollectionsSagas from 'app/ducks/paymentCollections/sagas';
import dashboardTeamPaymentRequestsSagas from 'app/ducks/dashboardTeamPaymentRequests/sagas';
import teamPaymentRequestsSagas from 'app/ducks/teamPaymentRequests/sagas';
import teamPaymentRequestMetricsSagas from 'app/ducks/teamPaymentRequestMetrics/sagas';
import teamPaymentCollectionsSagas from 'app/ducks/teamPaymentCollections/sagas';
import paymentEventsSagas from 'app/ducks/paymentEvents/sagas';
import receiptsSagas from 'app/ducks/receipts/sagas';
import purchasesSagas from 'app/ducks/purchases/sagas';
import creditCardsSagas from 'app/ducks/creditCards/sagas';
import forfeitsSagas from 'app/ducks/forfeits/sagas';
import competitionsSagas from 'app/ducks/competitions/sagas';
import groupsSagas from 'app/ducks/groups/sagas';
import organisationSectionsSagas from 'app/ducks/organisationSections/sagas';
import remindersSagas from 'app/ducks/reminders/sagas';
import onBoardingSagas from 'app/ducks/onboarding/sagas';
import invitationSagas from 'app/ducks/invitations/sagas';
import reportsSagas from 'app/ducks/reports/sagas';
import seasonsSagas from 'app/ducks/seasons/sagas';
import payoutsSagas from 'app/ducks/payouts/sagas';
import payoutLineItemsSagas from 'app/ducks/payoutLineItems/sagas';
import teamMemberSummariesSagas from 'app/ducks/teamMemberSummaries/sagas';
import bulkImportsSagas from 'app/ducks/bulkImports/sagas';

import rootReducer from 'app/redux/reducer';

const sagaMiddleware = createSagaMiddleware();
// const logger = createLogger({level:'info', collapsed:true});

// const middlewares = [
//   ReduxThunk, logger, require('redux-immutable-state-invariant')()
// ];

const middlewares = [
  ReduxThunk,
  require('redux-immutable-state-invariant').default(),
  sagaMiddleware,
];

// By default we try to read the key from ?debug_session=<key> in the address bar
// const getDebugSessionKey = function() {
//   const matches = window.location.href.match(/[?&]debug_session=([^&]+)\b/);
//   return (matches && matches.length)
//     ? matches[1]
//     : null;
// };

const enhancer = compose(applyMiddleware(...middlewares));

export default function configureStore(initialState) {
  const store = createStore(rootReducer, initialState, enhancer);
  typeof DD_LOGS ?? DD_LOGS.logger.info('debug-persist-store', {
    env: ENVIRONMENT,
    response: persistStore,
  });
  const persistor = persistStore(store);

  sagaMiddleware.run(addressesSagas);
  sagaMiddleware.run(authenticationSagas);
  sagaMiddleware.run(bankAccountsSagas);
  sagaMiddleware.run(bulkMatchPaymentsSagas);
  sagaMiddleware.run(clubsSagas);
  sagaMiddleware.run(competitionsSagas);
  sagaMiddleware.run(creditCardsSagas);
  sagaMiddleware.run(forfeitsSagas);
  sagaMiddleware.run(globalSagas);
  sagaMiddleware.run(groupsSagas);
  sagaMiddleware.run(invitationSagas);
  sagaMiddleware.run(loadingSagas);
  sagaMiddleware.run(matchPaymentsSagas);
  sagaMiddleware.run(onBoardingSagas);
  sagaMiddleware.run(organisationSectionsSagas);
  sagaMiddleware.run(organisationsSagas);
  sagaMiddleware.run(paymentCollectionsSagas);
  sagaMiddleware.run(paymentEventsSagas);
  sagaMiddleware.run(paymentsSagas);
  sagaMiddleware.run(payoutLineItemsSagas);
  sagaMiddleware.run(payoutsSagas);
  sagaMiddleware.run(purchasesSagas);
  sagaMiddleware.run(receiptsSagas);
  sagaMiddleware.run(remindersSagas);
  sagaMiddleware.run(reportsSagas);
  sagaMiddleware.run(seasonsSagas);
  sagaMiddleware.run(teamConnectionsSagas);
  sagaMiddleware.run(teamMembersSagas);
  sagaMiddleware.run(teamPaymentCollectionsSagas);
  sagaMiddleware.run(teamPaymentRequestMetricsSagas);
  sagaMiddleware.run(dashboardTeamPaymentRequestsSagas);
  sagaMiddleware.run(teamPaymentRequestsSagas);
  sagaMiddleware.run(teamsSagas);
  sagaMiddleware.run(usersSagas);
  sagaMiddleware.run(teamMemberSummariesSagas);
  sagaMiddleware.run(bulkImportsSagas);

  // Enable hot module replacement for reducers (requires Webpack or Browserify HMR to be enabled)
  // if (module.hot) {
  //   module.hot.accept('../reducer', () => {
  //     const nextReducer = require('../reducer').default;
  //     store.replaceReducer(nextReducer);
  //   });
  // }

  return { persistor, store };
}
